import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function getCurrentIndex(swiper) {
  return swiper.realIndex | 0;
}

function getTotalSlides(swiper) {
  return swiper.slides.length - (swiper.params.loop ? 2 : 0);
}

function changeSlide(swiper, index) {
  const currentIndex = getCurrentIndex( swiper );
  const total = getTotalSlides( swiper );

  if (currentIndex !== index) {
    if (swiper.params.loop) {
      if ((index === 0 && currentIndex === total - 1) || index === currentIndex + 1) {
        swiper.slideNext();
      } else if ((index === total - 1 && currentIndex === 0) || index === currentIndex - 1) {
        swiper.slidePrev();
      } else {
        swiper.slideTo( index + 1 );
      }
    } else {
      swiper.slideTo( index );
    }
  }
}

function controlSwiper(controller, target) {
  controller.on( 'transitionStart', function () {
    const index = getCurrentIndex( controller );
    changeSlide( target, index );
  } );
}

function initPeopleSlider() {
  const peopleSlider = new Swiper( '.our-people--slider', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: true,
    freeMode: true,
  } );
}

function initPOVSlider() {
  const mainSwiper = document.querySelector( '.pov-slider--main' );
  const thumbsSwiper = document.querySelector( '.pov-slider--thumbs' );

  const swiperThumbs = new Swiper( '.pov-slider--thumbs', {
    spaceBetween: 24,
    slidesPerView: 'auto',
    a11y: true,
    simulateTouch: false,
    on: {
      slideChange: s => {
        if (window.innerWidth > 600) {
          s.translateTo( 0, 0 );
        }
      },
    },
  } );

  const swiperMain = new Swiper( '.pov-slider--main', {
    observer: true,
    a11y: true,
    spaceBetween: 24,
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    keyboard: true,
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    thumbs: {
      swiper: swiperThumbs,
    },
    on: {
      afterInit: s => {
        window.addEventListener( 'load', (event) => {
          setSliderHeight( s );
        } );
      },
      slideChange: s => {
        setSliderHeight( s );
      },
    },
  } );


  if (mainSwiper && thumbsSwiper) {
    window.addEventListener( 'keydown', (event) => {
      const activeIndex = swiperMain?.activeIndex;
      const currentThumb = document.querySelector( `[data-slide-index="${activeIndex}"]` );

      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        currentThumb.focus();
      }
    } );
  }

  const slideActivators = document.querySelectorAll( '[data-slide-index]' );

  if (slideActivators.length) {
    [...slideActivators].forEach( (element) => {
      element.addEventListener( 'click', (event) => {
        event.preventDefault();
        const indexToSlideTo = element.getAttribute( 'data-slide-index' );

        swiperThumbs.slideTo( indexToSlideTo );
        swiperMain.slideTo( indexToSlideTo );
      } );
    } );
  }

  controlSwiper( swiperMain, swiperThumbs );
  controlSwiper( swiperThumbs, swiperMain );
}

function initGallerySlider() {
  const gallerySlider = new Swiper( ".gallery--slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: true,
    a11y: true,
    spaceBetween: 24,
    autoHeight: true,
    keyboard: true,
  } );
}

function setSliderHeight(swiper) {
  if (window.innerWidth > 600) {
    const currentSlideHeight = swiper.slides[swiper.realIndex].offsetHeight;
    const mainSlider = document.querySelector( '.pov-slider--main' );
    const desiredSlideHeight = currentSlideHeight * 1.3;

    mainSlider.style.height = desiredSlideHeight + 'px';
  }
}

export default {
  init() {
    initPOVSlider();
    initPeopleSlider();
    initGallerySlider();
  },
};